<div style="padding-bottom: 1em">
    <mat-expansion-panel class="groupFeatureCard"
        *ngFor="let commonFeature of productCommonFeatures; let i = index">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="groupName">{{ commonFeature.featureName }}</div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        
        <div class="group-feature-list">
            <div *ngFor="let entry of commonFeature.entryNames; let first = first" class="gridContainer table-border"
                [ngStyle]="first ? { borderTop: 'none' } : {}">
                <div class="feature" #featureElement>
                    {{ entry }}
                </div>
                <div></div>
                <mat-icon class="green-confirm" style="justify-self: center;">done</mat-icon>
            </div>
        </div>
    </mat-expansion-panel>
</div>